import React from 'react';

import styled from 'styled-components';
import Headline3 from '@joinforma/ui/components/Headline3';
import Title1 from '@joinforma/ui/components/Title1';
import Title2 from '@joinforma/ui/components/Title2';
import Modal from '@joinforma/ui/components/Modal';
import Body1 from '@joinforma/ui/components/Body1';
import Divider from '@joinforma/ui/components/Divider';

import { ReactComponent as CloseSvg } from '@joinforma/ui/assets/icons/close.svg';
import { ReactComponent as ArrowLeftSvg } from '@joinforma/ui/assets/icons/arrow-left.svg';

interface Props {
  is_open: boolean;
  title: string;
  subtitle?: string;
  description?: string;
  children?: JSX.Element;
  is_replace_address_open?: boolean;
  card_action_description?: string;
  onBack?: () => void;
  onCancel: () => void;
}

const Container = styled.div``;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -27px 0 21px;
`;
const Title = styled.div`
  display: flex;
  align-items: center;
`;

const Description = styled(Body1)`
  display: inline-block;
  margin: 24px 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const Subtitle = styled(Title2)`
  display: inline-block;
  margin: 24px 0 0;
`;

const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
`;

const BackButton = styled(CloseButton)`
  margin-right: 15px;
`;

const CardActionContainer = styled.div`
  margin: 24px 0 0;
`;

const Text = styled(Body1)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const PhoneNumber = styled(Title1)`
  margin: 0 6px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const CardActionDescription = ({
  card_action_description,
}: {
  card_action_description: string;
}) => (
  <CardActionContainer>
    <Text>Please call</Text>
    <PhoneNumber>1-833-333-0417</PhoneNumber>
    <Text>{card_action_description}</Text>
  </CardActionContainer>
);

const CardActionModal = ({
  is_open,
  title,
  description,
  subtitle,
  onCancel,
  onBack,
  is_replace_address_open,
  card_action_description,
  children,
}: Props) => (
  <Modal open={is_open} onClose={onCancel} hideCloseButton>
    <Container>
      <HeaderContainer>
        <Title>
          {is_replace_address_open && (
            <BackButton onClick={onBack}>
              <ArrowLeftSvg />
            </BackButton>
          )}
          <Headline3>{title}</Headline3>
        </Title>
        <CloseButton onClick={onCancel}>
          <CloseSvg />
        </CloseButton>
      </HeaderContainer>
      <Divider />
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {description && <Description>{description}</Description>}
      {card_action_description && (
        <CardActionDescription
          card_action_description={card_action_description}
        />
      )}
      {children}
    </Container>
  </Modal>
);

export default CardActionModal;
